import { Button } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

export const ActionsLabel = styled.label`
  line-height: 24px;
  font-size: 16px;
  margin: 0 0 0 4px;
`

export const ActionButton = styled(Button)`
  height: 44px;
`

export const ActionButtonWithTrailingSpace = styled(ActionButton)`
  margin-right: 4px;
`
